
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: ['videoSetId'],
  setup() {
    const acredoVideoUrl: string = 'https://video-acredo.acredo.com/'

    return { acredoVideoUrl }
  },
})
